import classes from '../Pages.module.css';
import {Row,Col, Tabs, Skeleton, message} from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext} from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import BasicSalaryAdvanceDetails from './BasicSalaryAdvanceDetails';
import AdvanceFormDetails from './AdvanceFormDetails';

const { TabPane } = Tabs;

const AdvanceFormView = (props) => {
    const { id } = useParams();
    const employeeData = useContext(DataContext)
    const history = useNavigate();

    const [editMode, setEditMode] = useState(true)
    const [loading, setLoading] = useState(false)
    const [allData, setAllData] = useState(null)
    const [ad, setAD] = useState(null)
    const [storeData, setStoreData] = useState(null)

    useEffect(() => {

        setAllData(null)
        setStoreData(null)
        setAD(null)
        setLoading(false)
        axios
        .get(employeeData.URL + '/api/v1/norms/salary-advance/additional-data',{
            withCredentials: true
        })
        .then((response) => {

            console.log(response);
            setAD(ad => {
                let newad = response.data.data
                return({
                    ...newad,
                  
                });
            })
        })
        .catch((error) => {
            console.log(error);
        })

        axios
            .get(employeeData.URL + '/api/v1/norms/salary-advance/' + id,{
                withCredentials: true
            })
            .then((response) => {

                console.log(response);
                setAllData(allData => {
                    const newData = response.data.data
                    return newData
                })

                setStoreData(allData => {
                    const newData = response.data.data
                    return newData
                })

            })
            .catch((error) => {
                console.log(error);
            })
        
            
    }, [])

    const handleSave = (event) => {

        var formv = true
        let count = 0;
        allData.details.rows.forEach(data => {
            
            if(!data){

                formv = formv&&false
                if(count === 0){
                    message.error({
                        content: 'Empty Fields In SALARY ADVANCE DETAILS Tab!!!',
                        className: 'custom-class',
                        style: {
                            marginTop: '1vh',
                        },
                    });
                }

                count = count + 1;
            }
        })
        
        if(formv){

            console.log("Submitting");
           
            const postData = {
              "header": allData.header.rows,
              "details": allData.details.rows,
            }

            const postDataS = {
                "header": storeData.header.rows,
                "details": storeData.details.rows,
            }
            
            postData.details.forEach((lang,index) => {

                if(!lang.ADVANCE_CD){
                    postData.details[index] = {
                        ...lang,
                        PARAM: "INSERT"
                    }
                }
    
                else{
                    postData.details[index] = {
                        ...lang,
                        PARAM: "UPDATE"
                    } 
                }
            })
    
            postDataS.details.forEach((lang,index) => {
                const dataIndex = postData.details.findIndex(element => element.ADVANCE_CD === lang.ADVANCE_CD)
                if(dataIndex === -1){
                    postData.details.push({
                        ADVANCE_CD: lang.ADVANCE_CD,
                        PARAM: "DELETE"
                    })
                }
            })
            
            console.log(JSON.stringify(postData, undefined, 2));
            setLoading(true)
            axios
              .patch(employeeData.URL + '/api/v1/norms/salary-advance/' + postData.header[0]['ADVANCE_CODE'], postData,  {
                  withCredentials: true,
                  credentials: 'include',
              })
              .then((response) => {
                  message.success({
                      content: 'salary advance Updated Successfully!!!',
                      className: 'custom-class',
                      style: {
                          marginTop: '2vh',
                      },
                  });
                  setLoading(false)
                  history.replace('/payroll/norms/salary-advance')
              })
              .catch((err) => {
                  message.error({
                      content: 'An Error Occurred!!!!',
                      className: 'custom-class',
                      style: {
                          marginTop: '2vh',
                      },
                  });
                  setLoading(false)
              });
          }
    }

    const handleCancel = (event) => {

        setLoading(false)
        history.replace('/payroll/norms/salary-advance')
    }

    return(
        allData && storeData && ad
        ?
        <Row className = {classes['RowP']}>
            <Col lg = {editMode ? 13 : 19} md = {editMode ? 13 : 19} className = {classes['Col']} >

            </Col>
            {
                editMode
                ?
                <>
                   <Col md = {4} >
                        {
                          loading
                          ?
                          <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                          :
  <button
                                                                                                 style={{
                                                                                                   padding: "7px 30px 14px 24px",
                                                                                                   borderRadius: "50px",
                                                                                                   background: "transparent",
                                                                                                   width: "100%",
                                                                                                   border: "none",
                                                                                                   outline: "none",
                                                                                                   fontSize: "16px",
                                                                                                   fontWeight: "600",
                                                                                                   lineHeight: "1.5",
                                                                                                   color: "#071e54",
                                                                                                   WebkitAppearance: "none",
                                                                             
                                                                                                   boxShadow:
                                                                                                     "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                                                                                   height: "40px",
                                                                             
                                                                                                   // Ensure the button takes full width
                                                                                                 }}
                                                                                                 onClick={(event) => handleSave(event)}
                                                                                                 className={classes["ProfileButtonn"]}
                                                                                                 id="save"
                                                                                                 onMouseOver={(event) => {
                                                                                                   event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                                                                                 }}
                                                                                                 onMouseOut={(event) => {
                                                                                                   event.target.style.boxShadow =
                                                                                                     "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                                                                                 }}
                                                                                               >
                                                                                                 Save
                                                     </button>
                        }
                        
                    </Col>
                    <Col md = {4} >
                        {
                          loading
                          ?
                          <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                          :
                          <button
                                                                      style={{
                                                                        padding: "7px 30px 14px 24px",
                                                                        borderRadius: "50px",
                                                                        background: "transparent",
                                                                        width: "100%",
                                                                        border: "none",
                                                                        outline: "none",
                                                                        fontSize: "16px",
                                                                        fontWeight: "600",
                                                                        lineHeight: "1.5",
                                                                        color: "#071e54",
                                                                        WebkitAppearance: "none",
                                                  
                                                                        boxShadow:
                                                                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                                                        height: "40px",
                                                  
                                                                        // Ensure the button takes full width
                                                                      }}
                                                                      onClick={(event) => handleCancel(event)}
                                                                      onMouseOver={(event) => {
                                                                        event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                                                      }}
                                                                      onMouseOut={(event) => {
                                                                        event.target.style.boxShadow =
                                                                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                                                      }}
                                                                      className={classes["ProfileButtonn"]}
                                                                    >
                                                                      Cancel
                                                    </button>
                        }
                    </Col>
                </>
                :
                <Col md = {4} >
                    <button onClick = {() => setEditMode(true)} className = {classes['ProfileButton']}>Edit Details</button>
                </Col>
            }
            <Col lg = {1} md = {1} >

            </Col>
            <Col lg = {24} md = {24} className = {classes['Col']}>
                <p></p>
                <div className = {classes['EditView']}>
                    <Tabs defaultActiveKey="0" centered style = {{ height: "100%"}} tabPosition={"left"} type = "line" >
                        <TabPane tab= {<span>Basic Details</span>} key="0">
                            <BasicSalaryAdvanceDetails create = {false} ad = {ad} setData = {setAllData} data = {allData.header.rows[0]} editMode = {editMode} />
                        </TabPane>
                        <TabPane tab= {<span>Salary Advance  Details</span>} key="1">
                            <p></p>
                            <AdvanceFormDetails ad = {ad} editMode = {editMode}  setData = {setAllData} data = {allData.details.rows}/>
                        </TabPane>
                    </Tabs>
                </div>
            </Col>       
        
        </Row>
        :
        <>
            <Skeleton active = {true} />
            <Skeleton active = {true} />
            <Skeleton active = {true} />
            <Skeleton active = {true} />
        </>
    );
}

export default AdvanceFormView;